import { render } from "./ActivityInstructions.vue?vue&type=template&id=a57c5640&scoped=true"
import script from "./ActivityInstructions.vue?vue&type=script&lang=js"
export * from "./ActivityInstructions.vue?vue&type=script&lang=js"

import "./ActivityInstructions.vue?vue&type=style&index=0&id=a57c5640&scoped=true&lang=css"

import exportComponent from "/home/wsl-ubuntu/work-repos/ats-201-build-a-planet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57c5640"]])

export default __exports__